import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { finalize, firstValueFrom, Subject, takeUntil } from 'rxjs';
import { GetMerchantRequestParams, MerchantData } from './merchants.interface';
import { Router } from '@angular/router';
import { MerchantsService } from '../../services/merchants/merchants.service';
import { getOffset, showNotification } from 'src/app/shared/helpers/helpers';
import { ModalContent } from '../../shared/modal-content';
import { ModalComponent } from 'angular-custom-modal';
import { OptionItem } from '../../shared/types/api-responses.type';

// import { RolesService } from '../../services/roles/roles.service';

@Component({
  selector: 'app-merchants',
  templateUrl: './merchants.component.html',
  styleUrls: ['./merchants.component.css'],
})
export class MerchantsComponent implements OnInit, OnDestroy {
  @ViewChild('modal') modal!: ModalComponent;

  private destroy$ = new Subject<void>();
  loading = false;
  roles: OptionItem[] = [];

  modalData: ModalContent = new ModalContent({
    header: 'Confirmation',
    body: 'Are you sure you want to delete this merchant?',
    showCloseButton: true,
    showConfirmButton: true,
    closeButtonLabel: 'Cancel',
    confirmButtonLabel: 'Delete',
    closeButtonClass: 'btn-secondary',
    confirmButtonClass: 'btn-danger',
  });

  selectedId = '';

  params = new GetMerchantRequestParams();
  totalRows = 0;

  cols = [
    { field: 'no', title: 'No' },
    { field: 'code', title: 'Code' },
    { field: 'name', title: 'Name' },
    { field: 'user', title: 'User' },
    { field: 'password', title: 'Password' },
    { field: 'secret_code', title: 'Secret Code' },
    { field: 'expired_date', title: 'Expired Date' },
    //{ field: 'payment_type', title: 'Payment Type' },
    { field: 'payment_type_name', title: 'Payment Type' },
    { field: 'balance', title: 'Balance' },
    { field: 'bank_account', title: 'Bank Account' },
    { field: 'bank_name', title: 'Bank Name' },
    { field: 'bank_branch', title: 'Bank Branch' },
    { field: 'add_params1', title: 'Add Params 1' },
    { field: 'add_params2', title: 'Add Params 2' },
    { field: 'action', title: 'Action', type: 'action' },
  ];

  pageSizeOptions = [5, 10, 25, 50, 100];
  rows: MerchantData[] = [];

  constructor(
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private merchantService: MerchantsService // private readonly roleService: RolesService,
  ) {}

  ngOnInit(): void {
    this.getMerchants();
    // this.getRoleData().then();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMerchants(): void {
    this.loading = true;
    this.rows = [];

    // alert(123);
    this.merchantService
      .getMerchantService(this.params)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: (response) => {
          this.rows = this.processDataForTable(response.data);
          this.totalRows = response.totalPage;
        },
        error: (err) => console.error('Error fetching merchant data:', err),
      });
  }

  processDataForTable(data: MerchantData[]) {
    const formattedData = data.map((each, i) => ({
      ...each,
      no: getOffset(this.params.pageNo, this.params.rowPerPage) + i + 1,
      expired_date: new Date(each.expired_date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }),
    }));

    console.log('Processed Data:', formattedData); // 🔍 Debug output

    return formattedData;
  }

  changeServer(data: any): void {
    this.params.pageNo = data.current_page;
    this.params.rowPerPage = data.pagesize;
    this.params.filter = data.search;
    this.getMerchants();
  }

  onInputChanged(value: string): void {
    console.log('Debounced Input:', value);
    this.params.filter = '';
    if (value) {
      this.params.filter = value;
    }
    this.cdRef.detectChanges();
  }

  onRoleChange(roleOption: OptionItem): void {
    this.params.roleId = null;
    if (roleOption) {
      console.log('Role Change:', roleOption.value);
      this.params.roleId = roleOption.value;
    }
    this.getMerchants();
  }

  goToForm(id: string): void {
    if (id === 'new') {
      this.router.navigate(['/merchants/new']).then();
      return;
    }
    this.router.navigate(['/merchants/edit', id]).then();
    return;
  }

  // private async getRoleData(): Promise<void> {
  //   try {
  //     const { data } = await firstValueFrom(this.roleService.getRoles());
  //     this.roles = data.map(role => ({ label: role.name, value: role.id }));
  //   } catch (error) {
  //     showNotification('error', 'Failed to fetch roles', JSON.stringify(error));
  //   }
  // }

  async deleteMerchant(id: string): Promise<void> {
    this.loading = true;

    try {
      const delResp = await firstValueFrom(this.merchantService.deleteMerchantById(id));
      showNotification('success', 'Success to delete merchant', JSON.stringify(delResp));
      this.getMerchants();
    } catch (error) {
      console.error('Delete Merchant Error:', error);
    } finally {
      this.loading = false;
    }
  }

  async onModalDeleteConfirm(id: string): Promise<void> {
    await this.deleteMerchant(id);
    this.modal.close();
  }
}
